import {useSuspenseQuery} from "@tanstack/react-query";

import {getRepresentativeQueryOptions} from "./get-representative.query-options";

export function useGetRepresentative(id: string, includeDeleted = false) {
  return useSuspenseQuery(getRepresentativeQueryOptions(id, includeDeleted));
}
